const uploadTypes = {
  image: { label: "Изображение", value: "1", allow: ".png,.jpg,.jpeg,.gif,.webp" },
  video: { label: "Видео", value: "2", allow: ".mp4,.mov,.avi" },
};

const storageTypes = [
  { label: "Склад реализации", value: 1 },
  { label: "Склад для возврата", value: 2 },
  { label: "Склад для резерва", value: 3 },
];

const colors = ["#7dc006", "#23b7e5", "#845ade", "#f5b74a", "#e6533c", "#259782", "#0ca5e9", "#a855f7", "#f97315"];

const salesByDay = [
  {
    doy: "32",
    count: 47,
    goods_count: 47,
    sum: 9244000,
    goods_coming_price: "6877641",
    avg: "196681",
    date: "2024-02-01 09:13:29",
  },
  {
    doy: "33",
    count: 58,
    goods_count: 58,
    sum: 7087500,
    goods_coming_price: "5160309.1",
    avg: "122198",
    date: "2024-02-02 09:10:55",
  },
  {
    doy: "34",
    count: 68,
    goods_count: 68,
    sum: 13695000,
    goods_coming_price: "9822747",
    avg: "201397",
    date: "2024-02-03 09:27:17",
  },
  {
    doy: "35",
    count: 81,
    goods_count: 81,
    sum: 14807500,
    goods_coming_price: "11297440.5",
    avg: "182809",
    date: "2024-02-04 08:25:17",
  },
  {
    doy: "36",
    count: 45,
    goods_count: 45,
    sum: 9676000,
    goods_coming_price: "7381752",
    avg: "215022",
    date: "2024-02-05 09:57:25",
  },
  {
    doy: "37",
    count: 28,
    goods_count: 28,
    sum: 4949000,
    goods_coming_price: "3571127",
    avg: "176750",
    date: "2024-02-06 12:57:05",
  },
  {
    doy: "38",
    count: 49,
    goods_count: 49,
    sum: 17444000,
    goods_coming_price: "12363648.2",
    avg: "356000",
    date: "2024-02-07 09:42:42",
  },
  {
    doy: "39",
    count: 46,
    goods_count: 46,
    sum: 9680000,
    goods_coming_price: "7531080.5",
    avg: "210435",
    date: "2024-02-08 08:14:55",
  },
  {
    doy: "40",
    count: 51,
    goods_count: 51,
    sum: 9296000,
    goods_coming_price: "6505811",
    avg: "182275",
    date: "2024-02-09 09:59:32",
  },
  {
    doy: "41",
    count: 34,
    goods_count: 34,
    sum: 5507000,
    goods_coming_price: "3983219",
    avg: "161971",
    date: "2024-02-10 10:14:11",
  },
  {
    doy: "42",
    count: 55,
    goods_count: 55,
    sum: 8591500,
    goods_coming_price: "6076787.5",
    avg: "156209",
    date: "2024-02-11 09:11:37",
  },
  {
    doy: "43",
    count: 32,
    goods_count: 32,
    sum: 5624500,
    goods_coming_price: "4257200.515",
    avg: "175766",
    date: "2024-02-12 10:32:33",
  },
  {
    doy: "44",
    count: 35,
    goods_count: 35,
    sum: 9509000,
    goods_coming_price: "6824329",
    avg: "271686",
    date: "2024-02-13 09:47:28",
  },
  {
    doy: "45",
    count: 25,
    goods_count: 25,
    sum: 9410000,
    goods_coming_price: "6019514.4",
    avg: "376400",
    date: "2024-02-14 09:43:50",
  },
  {
    doy: "46",
    count: 20,
    goods_count: 20,
    sum: 6170000,
    goods_coming_price: "4670698",
    avg: "308500",
    date: "2024-02-15 09:55:25",
  },
  {
    avg: 0,
    count: 0,
    date: "2024-02-16 09:55:25",
    goods_coming_price: 0,
    goods_count: 0,
    sum: 0,
  },
  {
    avg: 0,
    count: 0,
    date: "2024-02-17 09:55:25",
    goods_coming_price: 0,
    goods_count: 0,
    sum: 0,
  },
  {
    avg: 0,
    count: 0,
    date: "2024-02-18 09:55:25",
    goods_coming_price: 0,
    goods_count: 0,
    sum: 0,
  },
  {
    avg: 0,
    count: 0,
    date: "2024-02-19 09:55:25",
    goods_coming_price: 0,
    goods_count: 0,
    sum: 0,
  },
  {
    avg: 0,
    count: 0,
    date: "2024-02-20 09:55:25",
    goods_coming_price: 0,
    goods_count: 0,
    sum: 0,
  },
  {
    avg: 0,
    count: 0,
    date: "2024-02-21 09:55:25",
    goods_coming_price: 0,
    goods_count: 0,
    sum: 0,
  },
  {
    avg: 0,
    count: 0,
    date: "2024-02-22 09:55:25",
    goods_coming_price: 0,
    goods_count: 0,
    sum: 0,
  },
  {
    avg: 0,
    count: 0,
    date: "2024-02-23 09:55:25",
    goods_coming_price: 0,
    goods_count: 0,
    sum: 0,
  },
  {
    avg: 0,
    count: 0,
    date: "2024-02-24 09:55:25",
    goods_coming_price: 0,
    goods_count: 0,
    sum: 0,
  },
  {
    avg: 0,
    count: 0,
    date: "2024-02-25 09:55:25",
    goods_coming_price: 0,
    goods_count: 0,
    sum: 0,
  },
];

const salesByCategory = [
  {
    name: "Кофе",
    quantity: "1559",
    price: 120065500,
  },
  {
    name: "Вафли",
    quantity: "136",
    price: 8605500,
  },
  {
    name: "Печеные",
    quantity: "33",
    price: 3637000,
  },
  {
    name: "Молочный союз",
    quantity: "13",
    price: 2370000,
  },
  {
    name: "Cappuccino",
    quantity: "7",
    price: 1195000,
  },
  {
    name: "Лапша",
    quantity: "26",
    price: 800000,
  },
  {
    name: "Конфеты",
    quantity: "4",
    price: 770000,
  },
  {
    name: "Молочка",
    quantity: "4",
    price: 735000,
  },
  {
    name: "Орешки",
    quantity: "3",
    price: 720000,
  },
];
export const constants = {
  salesByCategory,
  salesByDay,
  colors,
  storageTypes,
  uploadTypes,
  GROUP_TYPE_CATEGORY: 1,
  GROUP_TYPE_PRODUCT: 2,
  GROUP_TYPE_INVENTORY: 3,

  CAUSE_TYPE_REJECT: 1,
  CAUSE_TYPE_RETURN: 2,

  BRAND_TYPE_BRAND: 1,
  BRAND_TYPE_MANUFACTURER: 2,

  PRODUCT_PARAM_TYPE_PACKAGE: 1,
  PRODUCT_PARAM_TYPE_SEGMENT: 2,

  CATEGORY_TYPE_PRODUCT: 1,
  CATEGORY_TYPE_PHOTO_REPORT: 2,
  CATEGORY_TYPE_DISH: 3,
};
